import { useEffect, useState } from "react";
import { Loader2, Sprout, CircleOff, Satellite } from "lucide-react";
import { api } from "@/lib/api";
import { Ayuda } from "./Glosario";

const VERDE = ["activo", "emergencia", "permanente"];

/** Observación destacada "Estado actual del cultivo" (reutiliza el ciclo de siembra guardado; NDVI Sentinel-2). */
export function EstadoActual({ cod, padron }) {
  const [d, setD] = useState(null);
  const cargar = () => api.get("/portal/titulares/parcela/ciclo", { params: { cod, padron } }).then((r) => setD(r.data)).catch(() => setD({ estado: "error" }));
  const calcular = () => api.post("/portal/titulares/parcela/ciclo", null, { params: { cod, padron } }).then(cargar).catch(() => setD({ estado: "error" }));
  useEffect(() => { cargar(); }, [cod, padron]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (d?.estado !== "calculando") return undefined;
    const t = setInterval(cargar, 5000); return () => clearInterval(t);
  }, [d?.estado]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const a = d.actual;
  if (!a) return <div className="rounded-xl border border-[#eceeec] p-3 text-xs text-[#5f6f66] flex items-center gap-2" data-testid="estado-actual-pendiente">
    {d.estado === "calculando" ? <><Loader2 className="w-4 h-4 animate-spin" />Leyendo imágenes satelitales para el estado actual del cultivo… {d.avance || 0}%</>
      : <><Satellite className="w-4 h-4" />Estado actual del cultivo sin calcular · <button onClick={calcular} className="underline text-[#1f7a4d]" data-testid="estado-actual-calcular">Calcular ahora (2–4 min)</button></>}</div>;
  const verde = VERDE.includes(a.estado);
  const Ic = verde ? Sprout : CircleOff;
  return <div className={`rounded-xl border p-3 space-y-1 ${verde ? "border-[#b7e0c6] bg-[#eef8f1]" : "border-[#e6d3bd] bg-[#faf4ec]"}`} data-testid="estado-actual">
    <p className={`flex items-start gap-2 text-sm font-semibold ${verde ? "text-[#124a2f]" : "text-[#6b4423]"}`} data-testid="estado-actual-texto"><Ic className="w-4 h-4 mt-0.5 shrink-0" /><span>{a.texto}<Ayuda k="estado_actual" /><Ayuda k={verde ? "ndvi" : "barbecho"} /></span></p>
    {a.detalle && <p className="text-xs text-[#5f6f66] pl-6" data-testid="estado-actual-detalle">{a.detalle}</p>}
    {a.aviso_antiguedad && <p className="text-[11px] text-amber-700 pl-6" data-testid="estado-actual-antiguedad">{a.aviso_antiguedad}</p>}
    <p className="text-[10px] text-[#5f6f66] pl-6" data-testid="estado-actual-aviso">{a.nota}</p>
  </div>;
}
